import { css } from '@emotion/core'
import { Box } from '@chakra-ui/core'
import React from 'react'

// CSS for bubble animation
const bubbleAnimation = css`
  animation: bubble 1.4s infinite ease-in-out;
  @keyframes bubble {
    0%,
    80%,
    100% {
      transform: scale(0.8);
      opacity: 0.5;
    }
    40% {
      transform: scale(1.2);
      opacity: 1;
    }
  }
`

export const ThinkingDot = () => {
  return <Box width="12px" height="12px" borderRadius="50%" backgroundColor="#000" css={bubbleAnimation} />
}
